import { render, staticRenderFns } from "./SectionTournamentRun.vue?vue&type=template&id=dae98d3c&scoped=true&"
import script from "./SectionTournamentRun.vue?vue&type=script&lang=js&"
export * from "./SectionTournamentRun.vue?vue&type=script&lang=js&"
import style0 from "./SectionTournamentRun.vue?vue&type=style&index=0&id=dae98d3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae98d3c",
  null
  
)

export default component.exports